import React from 'react'
import { useSelector } from 'react-redux'

// Constants
import { DEFAULT_COLORS, tenantColors } from '../../_constants/colors'
import { isLender } from '../../_helpers/user-utils'
import { S_FormTracker } from './FormTracker.styles'

export const FormTracker = ({ sections, currentSection, onSectionChange = undefined }) => {
  const { env, authentication, user } = useSelector((state) => state)
  const loggedIn = authentication ? authentication.loggedIn : false
  const userType = user ? user.user_type : 'customer'
  const tenant = env.tenant
  const isUserLender = isLender(loggedIn, userType)
  const colors = isUserLender ? DEFAULT_COLORS : tenantColors[tenant]

  return (
    <S_FormTracker colors={colors}>
      <ol>
        {sections.map((section, i) => {
          const completed = i < currentSection ? `completed` : ''
          const active = i === currentSection ? `active` : ''
          const click = onSectionChange !== undefined ? `click` : ''
          return (
            <li
              className={`${completed} ${active} ${click}`}
              data-testid={`section-${i}`}
              key={i}
              onClick={() => {
                if (click) {
                  onSectionChange(i)
                }
              }}
            >
              <div className={`tracker-bar ${active} ${completed}`}></div>
              <div className={`label ${active} ${completed}`} data-testid={`section-title-${i}`}>
                <span className="step-number">{i + 1}.</span> {section.title}
              </div>
            </li>
          )
        })}
      </ol>
    </S_FormTracker>
  )
}
